import React from 'react';
import {useFormSubmit} from '../../../controllers/useSubmitForm';
import {Form} from '../../../components/form/Form';

export const CarouselAdForm = props => {
  const {
    route: {params},
    defaultValue,
    header = 'Add Carousel Ad',
    mode,
  } = props;
  let {onSubmit} = useFormSubmit({
    uri: '/carouselads',
    ...props,
  });
  const {department, product, row} = params;
  return (
    <Form
      api={`/carouselads/${row?._id}`}
      fields={{
        head_line: 1,
        description: 1,
        ad_creative_id: {ad_head_line: 1},
        image: 1,
        reference: 1,
        attachment: 1,
      }}
      onSubmit={onSubmit}
      header={header}
      submitAction={'Save'}
      defaultValues={{
        ...defaultValue,
        department: department?._id,
        product: product?._id,
        created_on: mode !== 'edit' ? new Date() : void 0,
        status: 'active',
      }}
      layoutFields={[
        {
          placeholder: 'Carousel',
          field: 'head_line',
          type: 'text',
        },
        {
          placeholder: 'Description',
          field: 'description',
          type: 'textArea',
        },
        {
          placeholder: 'Ad Creative',
          field: 'ad_creative_id',
          type: 'autoComplete',
          api: `/adcreatives`,
          suggestionField: 'ad_head_line',
          valueField: 'ad_head_line',
        },
        {
          field: 'reference',
          type: 'file',
          placeholder: 'Reference*',
          multiple: true,
        },
        {
          field: 'attachment',
          type: 'file',
          placeholder: 'Upload file*',
          multiple: true,
        },
      ]}
      {...props}
    />
  );
};

export const EditCarouselAdForm = props => {
  return <CarouselAdForm mode="edit" header={'Edit Carousel Ad'} {...props} />;
};
